import React, {useState, useEffect} from 'react'
import firebase from '../../firebase/config'
import {useHistory, Link} from 'react-router-dom';
import moment from 'moment';
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

function Clients() {

    const history = useHistory()
    const [nameValue, setNameValue] = useState(null);
    const [nroValue, setNroValue] = useState(null);
    const [clients, setClients] = useState([])
    const [clientsSearch, setClientsSearch] = useState([])
    const [orders, setOrders] = useState([])
    const [user, setUser] = useState({})
    const [client, setClient] = useState({})
    
    const [services, setServices] = useState([])
    const [service, setService] = useState({})
    
    
    const [daySelected, setDaySelected] = useState({})
    const [agendaDays, setAgendaDays] = useState([])
    const [horaSelected, setHoraSelected] = useState("")
    
    const [activeModal, setActiveModal] = useState(false)
    const [activeModalDays, setActiveModalDays] = useState(false)
    const [activeModalPets, setActiveModalPets] = useState(false)
    const [activeModalSuccess, setActiveModalSuccess] = useState(false)
    
    const [clientPets, setClientPets] = useState([])
    const [petSelected, setPetSelected] = useState({})

    const getServices = async(id) =>{
      let tipos = [];
      let tipos2 = [];
      
      await firebase.db.collection("Localidades").where("aliadoId", "==", id).get().then(val=>{
        val.docs.forEach(item=>{
          tipos.push(item.data())
        })
      })

      Promise.all(tipos.map(async (doc) => {
        
        firebase.db.collection("Localidades").doc(doc.localidadId).collection("Servicios").get().then(val=>{
          val.docs.forEach(item=>{
            let o1 = item.data()
            o1["nombreLocalidad"] = doc.nombreLocalidad
            tipos2.push(o1)
          })
        })

      }))

      console.log(tipos)
      console.log(tipos2)

      setTimeout(() => {
        setServices(tipos2)
      }, 500);

    }

    const getOrders = async(aliadoId) =>{
        let tipos = [];
        await firebase.db.collection('Ordenes').where("aliadoId", "==", aliadoId).get().then(val => {
          if(val.docs.length > 0){
            val.docs.forEach( item =>(item.data().walkin === undefined && item.data().aliado === undefined) &&  tipos.push(item.data().uid) )
            setOrders(tipos)
            getDueños(tipos)
          }
        })
    }

    const getDueños = async(orders) =>{
        let tipos = [];
        await firebase.db.collection('Dueños').get().then(val => {
          val.docs.forEach(item=>{
            tipos.push(item.data().uid)
          })
          getClients(tipos, orders)
        })
    }
        

    const getClients = (dueños, orders) =>{
        let tipos = []
        let ids = []
        for(let i = 0; i < orders.length; i++){
            let a = dueños.indexOf(orders[i])
            tipos.push(a)
        }
        let tipos2 = Array.from(new Set(tipos))
        for(let i = 0; i < tipos2.length; i++){
            let a = dueños[tipos2[i]]
            ids.push(a)
        }
        getDueños2(ids)
    }

    const getDueños2 = async(ids) =>{
        let tipos = [];
        for(let i = 0; i < ids.length; i++){
            await firebase.db.collection('Dueños').doc(ids[i]).get().then(val => {              
              tipos.push(val.data())
              console.log(val.data())
            })
        }
        setClients(tipos.sort())
        console.log(tipos)
    }
    
    const getDueños3 = async(val) =>{
      let tipos = []
      for(let i = 0; i < clients.length; i++){
        let u = clients[i].user.toLowerCase()
        if(u.includes(val.toLowerCase())){
          tipos.push(clients[i])
        }
      }
      setClientsSearch(tipos)
    }
    
    const getPlanUser = async(uid)=>{
      let plan
      try{
        await firebase.db.collection("Dueños").doc(uid).collection("Plan").get().then((val)=>{
          val.docs.forEach((doc)=>{
          })
          plan = val.docs[0].data()
        })
      }catch(e){
        console.log(`Error: ${e}`)
      }
      return plan
    }
    
    async function goToClient(uid){
      history.push({
        pathname: "/clients/client", 
        state: { uid: uid }
      })
    }

    const getPets = async(uid)=>{
      let tipos = []
      try{
        await firebase.db.collection("Mascotas").where("uid", "==", uid).get().then((val)=>{
          val.docs.forEach((doc)=>{
            tipos.push(doc.data())
          })
          setClientPets(tipos)
        })
      }catch(e){
        console.log(`Error: ${e}`)
      }
    }

    async function getDaysFromService(s){
      let tipos = [];
      
      setService(s)

      await firebase.db.collection("Localidades").doc(s.localidadId)
      .collection("Servicios").doc(s.servicioId).collection("Agenda").orderBy("createdOn", "asc").get().then(val=>{
        val.docs.forEach(item=>{
          let d = moment(item.data().date.toDate())
          let today = moment().subtract(1, "d")
          d.isSameOrAfter(today) && tipos.push(item.data())
        })
        setAgendaDays(tipos)
      })

    }
    
    const ExportToExcel = ({ apiData, fileName }) => {
      const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      
      let today = moment().format('L')

      const exportToCSV = async(d, fileName) => {
        await Promise.all(d.map(async (o) => {
          for(let v in o){
            v.toString() === "geolocation" && delete o[v]
            v.toString() === "geoAddress" && delete o[v]
            v.toString() === "url" && delete o[v]
            v.toString() === "tipoDocumento" && delete o[v]
            v.toString() === "fechaNacimiento" && delete o[v]
            v.toString() === "codigoTexto" && delete o[v]
            v.toString() === "token" && delete o[v]
            v.toString() === "docid" && delete o[v]
            v.toString() === "registroCompleto" && delete o[v]
            v.toString() === "location" && delete o[v]
            v.toString() === "id_culqi" && delete o[v]
            v.toString() === "uid" && delete o[v]
            v.toString() === "bienvenida" && delete o[v]
            v.toString() === "userCart" && delete o[v]
          }
          
        }))
        const ws = XLSX.utils.json_to_sheet(d);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, `clientes-${today}` + fileExtension);
      };
    
      return (
        <button className="btn btn-outline-secondary" onClick={(e) => exportToCSV(apiData, fileName)}>Exportar a Excel <i className="material-icons">save_alt</i></button>
      );
    }

    useEffect(() => {
        firebase.getCurrentUser().then((val)=>{
          setUser(val)
          getOrders(val.aliadoId)
          getServices(val.aliadoId)
        })
    }, [])

    return (

        <div className="main-content-container container-fluid px-4">
          { activeModalSuccess && <div className="cc-modal-wrapper fadeIn">
                <div className="c2-modal">
                    <div className="cc-modal-header mb-2">
                      <span className="mb-0 material-icons" style={{color: "var(--success)", fontSize: "69px"}}>check_circle</span>
                    </div>
                    <div className="c2-modal-body">
                       <p className="mb-0">
                        Cita creada exitosamente
                       </p>
                    </div>
                    <div className="cc-modal-footer align-items-center justify-content-spacebetween">
                      <button onClick={()=>{ setActiveModalSuccess(false) }} className={`btn btn-success btn-block`}>
                        Aceptar
                      </button>
                    </div>
                </div>
            </div>}
          { activeModal && 
            <div className="cc-modal-wrapper fadeIn">
              <div className="cc-modal">
                <div className="cc-modal-header mb-2">
                  <div className="no-gutters mb-3 row align-items-center justify-content-spacebetween">
                    <h3 className="mb-0">Selecciona el servicio</h3>
                  </div>
                </div>
                <div className="cc-modal-body">
                  {services.map((s)=>{
                    return (
                      <div onClick={()=>{ service === s ? setService({}) : getDaysFromService(s) }} className={`cc-modal-card-2 mx-1 cursor-pointer ${service === s ? "active" : "" }`} style={{backgroundImage: `url(${s.urlImagen})` }} key={s.servicioId}>
                        <div className="cc-modal-card-overlay">
                          <p className="mb-0 cc-modal-card-p">
                            {s.descripcion}
                          </p>
                          <p style={{width: "fit-content"}} className="pill-secondary rounded">{s.nombreLocalidad}</p>
                          <p className="mb-0 cc-modal-card-p-strong">
                            {s.titulo}
                          </p>
                        </div>
                      </div>
                    )
                  })}
                </div>
                <div className="cc-modal-footer align-items-center justify-content-spacebetween">

                  <button onClick={()=>{ setActiveModal(false) }} className={`btn btn-disabled`}>
                    Cancelar
                  </button>
                  <button onClick={()=>{ setActiveModalDays(true); setActiveModal(false) }} className={`btn ${ service.servicioId !== undefined ? "btn-primary" : "btn-disabled"}`}>
                    Continuar
                  </button>

                </div>
              </div>
            </div>
          }

            { activeModalDays && <div className="cc-modal-wrapper fadeIn">
              <div className="c3-modal">
                <div className="cc-modal-header mb-2">
                  <div className="no-gutters mb-3 row align-items-center justify-content-spacebetween">
                    <h3 className="mb-0">Selecciona el día y la hora</h3>
                  </div>
                </div>
                <div className="cc-modal-body">

                  <div style={{width: "inherit"}}>
                    <div className="agenda-days-slider">
                      {agendaDays.map((d, i)=>{
                        return (
                          <p className={`${daySelected === d && "day-active"} mb-0`} onClick={()=>{ setDaySelected(d) }} key={i}>
                            {d.bloqueado && <> <i className="material-icons">lock</i> <br/> </>}
                            {d.fecha}
                          </p>
                        )
                      })}
                    </div>
                      
                    { (service.tipoAgenda === "Slots" && daySelected.horasDia !== undefined  ) && 
                      <div className="mt-3 slots-day"> 
                        {
                          daySelected.horasDia.map((h, i)=> <div onClick={()=>{ setHoraSelected(h) }} className={`pill-secondary-2 ${horaSelected === h && "active"}`} key={i}>{h}</div>)
                        }
                      </div>
                    }

                  </div>
                </div>
                <div className="cc-modal-footer align-items-center justify-content-spacebetween">
                  <button onClick={()=>{ setActiveModalDays(false); setActiveModal(true); setDaySelected({}) }} className={`btn btn-disabled`}>
                    Volver
                  </button>
                  <button onClick={()=>{ setActiveModalDays(false); setActiveModalPets(true) }} className={`btn btn-primary`}>
                    Continuar
                  </button>
                </div>
              </div>
            </div> }
          
          { activeModalPets && 
            <div className="cc-modal-wrapper fadeIn">
              <div className="cc-modal">
                <div className="cc-modal-header mb-2">
                  <div className="no-gutters mb-3 row align-items-center justify-content-spacebetween">
                    <h3 className="mb-0">Selecciona la mascota</h3>
                  </div>
                </div>
                <div className="cc-modal-body">
                  {clientPets.map((p)=>{
                    return (
                      <div onClick={()=>{ petSelected === p ? setPetSelected({}) : setPetSelected(p) }} className={`cc-modal-card-2 mx-1 cursor-pointer ${petSelected === p ? "active" : "" }`} style={{backgroundImage: `url(${p.petthumbnailUrl})` }} key={p.mid}>
                        <div className="cc-modal-card-overlay">
                          <p className="mb-0 cc-modal-card-p">
                            {p.especie}
                          </p>
                          <p className="mb-0 cc-modal-card-p-strong">
                            {p.nombre}
                          </p>
                        </div>
                      </div>
                    )
                  })}
                </div>
                <div className="cc-modal-footer align-items-center justify-content-spacebetween">

                  <button onClick={()=>{ setActiveModalPets(false); setActiveModalDays(true); setPetSelected({}) }} className={`btn btn-disabled`}>
                    Cancelar
                  </button>
                  <button onClick={()=>{ createReservation() }} className={`btn ${ petSelected.mid !== undefined ? "btn-primary" : "btn-disabled"}`}>
                    Continuar
                  </button>

                </div>
              </div>
            </div>
          }

          <div>

              <div className="page-header align-items-center justify-content-spacebetween row no-gutters px-4 my-4">
                <div className="col-12 col-sm-5 text-center text-sm-left mb-0">
                  <div className="row align-items-center">
                    <div className="col">
                      <p className="page-title"><span>Clientes</span></p>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-1 mb-0">
                  <div className="row align-items-center justify-content-space-around">
                    {/* <i className="material-icons color-white display-5">help_outline</i> */}
                  </div>
                </div>
              </div>
              <div className="form-row align-items-center justify-content-space-between">
                  <div className="form-group mr-3">
                    <input type="text" placeholder="Nombre del cliente" className="form-control" onChange={(e)=>{getDueños3(e.target.value)}}/>
                  </div>
                  <div className="ml-3 form-group">
                    <button className="btn btn-primary" onClick={()=>{getDueños3(nameValue)}}><i className="material-icons">search</i></button>
                  </div>
                <div className="ml-3 form-group">
                  <Link to="/clients/create-client" className="btn btn-outline-secondary">Crear nuevo cliente</Link>              
                </div>
                <div className="ml-3 form-group">
                  <ExportToExcel apiData={clientsSearch.length > 0 ? clientsSearch : clients} fileName={"Clientes"} />
                </div>
              </div>
              <div className="row">
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="orders-container">
                      <div className="row orders-title align-items-center">
                        <div style={{width: "50px", height: "50px"}} ></div>
                        <div className="col-md-1 ">
                          <p className="mb-0">Nombre</p>
                        </div>
                        <div className="col-md-2 ">
                          <p className="mb-0">Dirección</p>
                        </div>
                        <div className="col-md-2 ">
                          <p className="mb-0">Telefono</p>
                        </div>
                        <div className="col-md-2 ">
                          <p className="mb-0">Email</p>
                        </div>
                        <div className="col-md-2 ">
                          <p className="mb-0"></p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="orders-container">
                      {
                        clientsSearch.length > 0 ? clientsSearch.map(client=>{
                          let plan = getPlanUser(client.uid)
                          return(
                            <div key={client.uid} className="mb-3 row client-child align-items-center">
                              <img onClick={()=>{goToClient(client.uid)}} className="client-avatar-preview rounded-circle mr-2 cursor-pointer" src={client.url ?? "cargando"} alt="User Avatar"/>
                              <div className="col-md-1 color-primary">
                                <p className="mb-0">{client.user}</p>
                              </div>
                              <div className="col-md-2 color-primary">
                                <p className="mb-0">{client.direccion}</p>
                              </div>
                              <div className="col-md-2 color-primary">
                                <p className="mb-0">{client.telefono}</p>
                              </div>
                              <div className="col-md-2 color-primary">
                                <p className="mb-0">{client.email}</p>
                              </div>
                              <div className="col-md-2 color-primary">
                                <p className="mb-0">{plan != undefined ? plan.tipoPlan : ""}</p>
                              </div>
                              <div onClick={()=>{ goToMessages(client.uid, client.user) }} className="col-md-1 material-icons cursor-pointer color-secondary"> send </div>
                              <div onClick={()=>{ 
                                setActiveModal(true);
                                setClient(client);
                                getPets(client.uid)
                               }} className="col-md-1 material-icons cursor-pointer color-secondary"> calendar_today </div>
                            </div>
                          )
                        }) : clientsSearch.length === 0 ? 
                          clients.map(client=>{
                            let plan = getPlanUser(client.uid)
                            return(
                              <div key={client.uid} className="mb-3 row client-child align-items-center">
                                <img onClick={()=>{goToClient(client.uid)}} className="client-avatar-preview rounded-circle mr-2 cursor-pointer" src={client.url ?? "cargando"} alt="User Avatar"/>
                                <div className="col-md-1 color-primary">
                                  <p className="mb-0">{client.user}</p>
                                </div>
                                <div className="col-md-2 color-primary">
                                  <p className="mb-0">{client.direccion}</p>
                                </div>
                                <div className="col-md-2 color-primary">
                                  <p className="mb-0">{client.telefono}</p>
                                </div>
                                <div className="col-md-2 color-primary">
                                  <p className="mb-0">{client.email}</p>
                                </div>
                                <div className="col-md-2 color-primary">
                                  <p className="mb-0">{plan != undefined ? plan.tipoPlan : ""}</p>
                                </div>
                                <div onClick={()=>{ goToMessages(client.uid, client.user) }} className="col-md-1 material-icons cursor-pointer color-secondary"> send </div>
                                <div onClick={()=>{ 
                                  setActiveModal(true);
                                  setClient(client);
                                  getPets(client.uid)
                                 }} className="col-md-1 material-icons cursor-pointer color-secondary"> calendar_today </div>

                              </div>
                            )
                          })
                        : <div className="text-center"><p>No hay clientes</p></div>
                      }
                    </div>
                  </div>
              </div>
            </div>

          </div>
    )

    async function createReservation(){
      try{
        setActiveModalPets(false);
        const oid = moment().valueOf().toString()
        // console.log(client)
        await firebase.db.collection("Ordenes").doc(oid).set({
          uid: client.uid,
          localidadId: service.localidadId,
          pais: user.pais,
          status: "Por confirmar",
          statusCita: "Por confirmar",
          nombreComercial: user.nombreComercial,
          titulo: service.titulo,
          oid: oid,
          aliadoId: user.aliadoId,
          servicioid: service.servicioId,
          date: daySelected.date,
          hora: horaSelected,
          fecha: daySelected.fecha,
          precio: service.precio,
          mid: petSelected.mid,
          user: client.user,
          tipoOrden: service.titulo === "Videoconsulta" ? "Videoconsulta" : "Servicio",
          videoId: "q2d_21VC",
          createdOn: moment().toDate()
        })
        await firebase.db.collection("Ordenes").doc(oid).collection("Items").doc(service.servicioId).set({
          aliadoId: user.aliadoId,
          date: daySelected.date,
          delivery: service.delivery,
          domicilio: service.domicilio,
          fecha: daySelected.fecha,
          hora: horaSelected,
          mid: petSelected.mid,
          nombre: petSelected.nombre,
          nombreComercial: user.nombreComercial,
          oid: oid,
          petthumbnailUrl: petSelected.petthumbnailUrl,
          precio: service.precio,
          servicioid: service.servicioId,
          tieneDelivery: false,
          tieneDomicilio: false,
          titulo: service.titulo,
          uid: client.uid,
        })

        setActiveModalSuccess(true);

      }catch(e){
        console.log("Error: " + e)
      }
    }

    async function goToMessages(ownerUid, ownerName){
      try{
        await firebase.db.collection("Chats").where("aliadoId", "==", user.aliadoId).get().then((val)=>{
          let tipos = []
          Promise.all(val.docs.map(async (doc) => {
            tipos.push(doc.data().uid)
          }))
          if(tipos.includes(ownerUid)){
            history.push({
              pathname: "/messages",
              state: {uid: ownerUid, fromClients: true}
            })
          }else{
            let id = firebase.db.collection("Chats").doc().id
            firebase.db.collection("Chats").doc(id).set({
              aliadoId: user.aliadoId,
              uid: ownerUid,
              chatId: id
            }).then(()=>{
              let mid = firebase.db.collection("Chats").doc(id).collection("Mensajes").doc().id
              firebase.db.collection("Chats").doc(id).collection("Mensajes").doc(mid).set({
                aliadoId: user.aliadoId,
                createdOn: moment().toDate(),
                message: `Saludos, ${ownerName}`,
                messageId: mid,
                uid: null,
              }).then(()=>{
                history.push({
                  pathname: "/messages",
                  state: {uid: ownerUid, fromClients: true}
                })
              })
            })
          }
        })
      }catch(e){
        console.log("Error: " + e)
      }
    }

}

export default Clients